import axios from '../shared/axios';
// import qs from 'querystring';
// import store from "../store/store";


export function importData(data) {
    return axios.post(`/api/Migration/Import`, data);
}

export function restart(migrationid, forcerestart) {
    return axios.post(`/api/Migration/RestartMigration`, null, { params: { migrationid,forcerestart} });
}

export function getRegisterList() {
    return axios.get(`/api/Migration/RegisterList`);
}

export function getFailedRecords(migrationid) {
    return axios.get(`/api/Migration/GetFailedRecords`, { params: { migrationid } });
}
